import {
    ApprovalBudgetKind,
    ApproveBudgetKind,
    BudgetStatus,
} from "@kase/my-marathon-communication";
import { ApprovalBudget } from "../approve/interfaces";
import {
    Budget,
    BudgetFeeLine,
    BudgetLine,
    BudgetOtherLine,
    BudgetPurchaseLine,
} from "./interfaces";

export const isFeeLine = (line: BudgetLine): line is BudgetFeeLine =>
    line.t === "A";

export const isPurchaseLine = (line: BudgetLine): line is BudgetPurchaseLine =>
    line.t === "I";

export const isOtherLine = (line: BudgetLine): line is BudgetOtherLine =>
    line.t === "O";

export const getBudgetApproval = (
    budgetId: string | null | undefined,
    budgets: Budget[],
    approvals: ApprovalBudget[],
) => {
    const budget = budgets.find((b) => b.id === budgetId);
    const relevantApprovals = approvals.filter(
        (a) => a.budget.toString() === budgetId,
    );
    const internalApprovals = relevantApprovals.filter(
        (a) => a.approval_kind === ApprovalBudgetKind.BudgetKindInternal,
    );
    const externalApprovals = relevantApprovals.filter(
        (a) => a.approval_kind === ApprovalBudgetKind.BudgetKindExternal,
    );
    const internalApproved =
        internalApprovals.length > 0 &&
        internalApprovals.every(
            (a) => a.kind === ApproveBudgetKind.BudgetKindApproved,
        );
    const externalApproved =
        externalApprovals.length > 0 &&
        externalApprovals.every(
            (a) => a.kind === ApproveBudgetKind.BudgetKindApproved,
        );
    const status = budget?.status ?? BudgetStatus.BudgetStatusNone;

    return {
        status,
        internal: {
            sent: status === BudgetStatus.BudgetStatusInternal,
            approved: internalApproved,
            approvals: internalApprovals,
        },
        external: {
            sent: status === BudgetStatus.BudgetStatusExternal,
            approved: externalApproved,
            approvals: externalApprovals,
        },
    };
};
